<template>
  <div class="helpServiceBox">
    <div class="helpcloginCon">
        <div class="bigTitle" @click="backFn('showa')"><span ></span>在线公证</div>
        <div v-if="showa">
          <p class="paragraph">在线公证，指的是在线申请公证书。</p>
          <p class="paragraph">公证书是指公证处根据当事人申请，依照事实和法律，按照法定程序制作的具有特殊法律效力的司法证明书，是司法文书的一种。 </p>
          <p class="paragraph"> 使用智签电子合同签约平台签约的所有合同，其整个签署行为所产生的电子数据都会实时存证至司法联盟链，同步至司法联盟链上的公证处节点，一旦发生纠纷，可在线提交申请至公证处出具公证书，提供具有强证明力的证据，保障用户的合法权益。</p>
          <p>操作步骤如下： </p>
          <div class="smallTile" v-for="(item,index) in flowList" >
            <p>{{item.con}} </p>
            <img :src="item.img" v-if="item.img!=''">
          </div>
        </div>
        <div class="bigTitle" @click="backFn('showb')"><span ></span>司法司法鉴定</div>
        <div v-if="showb">
         <p class="paragraph">
           在线司法鉴定，指的是在线申请司法鉴定意见书。
         </p>
         <p class="paragraph">
           司法鉴定意见书是司法鉴定人依照法律、法规和规章规定的条件和程序，运用科学技术或者专门知识对诉讼涉及的专门性问题进行鉴别和判断后为表达鉴定意见而制作的文书的。
         </p>
         <p class="paragraph">
           使用智签电子合同签约平台签约的所有合同，其整个签署行为所产生的电子数据都会实时存证至司法联盟链，同步至司法联盟链上的鉴定机构节点，一旦发生纠纷，可在线提交申请至司法鉴定机构出具鉴定意见书，提供具有强证明力的证据，保障用户的合法权益。
         </p>
         <p>
           操作步骤如下：
         </p>
         <div class="smallTile" v-for="(item,index) in serviceList" >
            <p>{{item.con}} </p>
            <img :src="item.img" v-if="item.img!=''">
          </div>
        </div>
        <div class="bigTitle" @click="backFn('showc')"><span ></span>在线律师服务</div>
        <div v-if="showc">
         <p class="paragraph">
          律师服务，指的是在线申请律师服务，智签电子合同平台与全国范围内的律师进行了广泛的合作，用户提交后，平台会依据案情，为用户匹配相应的律师，解决纠纷问题。
         </p>
         <p>
           操作步骤如下：
         </p>
         <div class="smallTile" v-for="(item,index) in lineList" >
            <p>{{item.con}} </p>
            <img :src="item.img" v-if="item.img!=''">
          </div>
        </div>
        <div class="bigTitle" @click="backFn('showd')"><span ></span>司法服务中的常见问题</div>
        <div class="helpItem" v-if="showd">
          <div v-for="item in realList">
            <p><span></span>{{item.problem}}</p>
            <p><span></span>{{item.answer}}</p>
          </div>
        </div>
    </div>  
  </div>
</template>
<script>
export default {
  data(){
    return{
      showa:false,
      showb:false,
      showc:false,
      showd:false,
      flowList:[
        {
          con:'1.司法服务-申请服务',
          img:''
        },
        {
          con:'2.选择要公证的合同，点击“申请公证”',
          img:require('../../../assets/images/helpCenter/sqgz.png')
        },
        {
          con:'3.填写申请公证名称',
          img:''
        },
        {
          con:'4.选择公证处所在地',
          img:''
        },
        {
          con:'5.选择公证处',
          img:''
        },
        {
          con:'6.选择领取人',
          img:''
        },
        {
          con:'7.填写备注',
          img:''
        },
        {
          con:'8.申请信息栏，填写公证书份数',
          img:''
        },
        {
          con:'9.联系信息栏，填写用户所在地，现居住地址，领取人手机号，领取人邮箱',
          img:require('../../../assets/images/helpCenter/txxx.png')
        },
        {
          con:'10.点击提交申请',
          img:''
        },
        {
          con:'11.审核通过，公证服务列表，支付',
          img:''
        },
        {
          con:'12.等待制证',
          img:''
        },
      ],
      serviceList:[
        {
          con:'1.司法服务-申请服务',
         img:''
        },
        {
          con:'2.选择要司法鉴定的合同，点击“司法鉴定”',
         img:require('../../../assets/images/helpCenter/sqsfjd.png')
        },
        {
          con:'3.填写申请名称',
         img:''
        },
        {
          con:'4.点击确定',
         img:''
        },
        {
          con:'5.服务列表-司法鉴定列表，点击详情查看证据',
         img:''
        },
      ],
      lineList:[
        {
          con:'1.司法服务-申请服务',
          img:''
        },
        {
          con:'2.选择要申请律师服务的合同，点击“申请律师服务”',
          img:require('../../../assets/images/helpCenter/sqlsfw.jpg')
        },
        {
          con:'3.填写申请名称',
          img:''
        },
        {
          con:'4.点击确定',
          img:''
        },
        {
          con:'5.服务列表-律师服务列表，点击详情查看证据',
          img:''
        },
      ],
      realList:[
        {
          problem:'在线公证和在线司法鉴定的费用怎么算？',
          answer:'在线公证和在线司法鉴定是专业的司法机构提供的服务，由相应的公证处或者司法鉴定机构按照国家或者行业标准进行收费，智签平台只提供相应的司法辅助通道服务。'
        },
        {
          problem:'出现纠纷一定要申请公证书或者司法鉴定意见书吗？',
          answer:'如果在智签电子签约平台签署的电子合同出现纠纷，智签电子签约平台可为用户出具第三方电子数据证明，用户可按照诉讼中的实际情况按需选择是否申请公证书或司法鉴定意见书。'
        },
      ]
    }
  },
  methods:{
    backFn(flag){
      if(this[flag]==true){
        this[flag]=false;
      }else{
        this[flag]=true;
      }
    }
  }
}
</script>
<style lang="scss">
.helpServiceBox{
  .helpcloginCon{
    p{
      font-size: 13px;
      color: #828282;
      line-height: 25px;
      margin-left:10px;
    }
    .paragraph{
      text-indent: 2em;
      margin-bottom:10px;
    }
  }
}
</style>
